import { Box, type BoxProps } from '@mui/material';
import { m } from 'motion/react';
import { varContainer } from './variants/container';

export interface Props extends BoxProps {
  animate?: boolean;
  action?: boolean;
}

export default function MotionContainer({
  animate,
  action = false,
  children,
  sx,
  ...other
}: Props) {
  if (action) {
    return (
      <Box sx={sx} {...other}>
        <m.div initial={false} animate={animate ? 'animate' : 'exit'} variants={varContainer()}>
          {children}
        </m.div>
      </Box>
    );
  }

  return (
    <Box sx={sx} {...other}>
      <m.div initial="initial" animate="animate" exit="exit" variants={varContainer()}>
        {children}
      </m.div>
    </Box>
  );
}
